const Guidlines: React.FunctionComponent = () => {
  return (
    <div className='guidlines'>
      <div className='wrapper__top'>
        <div className='wrapper__guidline wrapper__guidline--tl'></div>
        <div className='wrapper__guidline wrapper__guidline--tr'></div>
      </div>

      <div className='wrapper__bottom'>
        <div className='wrapper__guidline wrapper__guidline--bl'></div>
        <div className='wrapper__guidline wrapper__guidline--br'></div>
      </div>
    </div>
  );
};

export default Guidlines;
